import { render, staticRenderFns } from "./ExtraDocuments.vue?vue&type=template&id=0d45d996&"
import script from "./ExtraDocuments.vue?vue&type=script&lang=ts&"
export * from "./ExtraDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports